<div class="sr-only" role="status" aria-live="assertive" aria-atomic="true">
    {{screenReaderAnnouncement}}
</div>
<div class="drop-list-group" cdkDropListGroup fxLayout="row" fxLayoutGap="1rem">
    @for (list of groups; track list; let groupIndex = $index) {
    <div fxLayout="column" style="width: 100%;">
        <div class="forge-typography--heading2">{{groupTitles?.[groupIndex]}}</div>
        <forge-list cdkDropList [cdkDropListData]="list" (cdkDropListDropped)="onCdkDropListDropped($event)"
            class="drag-drop-container">
            @for (item of list; track item; let itemIndex = $index) {
            <forge-list-item cdkDrag [cdkDragLockAxis]="lockVerticalDrag" tabindex="0"
                role="button"
                [attr.data-group-index]="groupIndex"
                [attr.data-item-index]="itemIndex"
                [attr.aria-label]="getItemAriaLabel(item, groupIndex, itemIndex)"
                [attr.aria-pressed]="isMoving(groupIndex, itemIndex)"
                [class.keyboard-moving]="isMoving(groupIndex, itemIndex)"
                (keydown)="onItemKeyDown($event, groupIndex, itemIndex)"
                (blur)="onItemBlur($event)">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="column">
                        <div class="forge-typography--body2">
                            <truncate-text [mainText]="getDisplay(item)"></truncate-text>
                        </div>
                        <div class="forge-typography--label1">
                            <truncate-text [mainText]="getSubtitle(item)"></truncate-text>
                        </div>
                    </div>
                    <forge-icon name="drag_indicator" style="--forge-icon-size: 1rem;"></forge-icon>
                </div>
            </forge-list-item>
            }
        </forge-list>
    </div>
    }
</div>
